/**
 * ExpressionCache — LRU cache for expression classification results.
 * Copied from v1 (safe, no changes needed).
 */

export interface CachedExpression {
  type: string
  value?: unknown
  [key: string]: unknown
}

export interface CacheStats {
  size: number
  hits: number
  misses: number
  hitRate: number
}

export class ExpressionCache {
  private map: Map<string, CachedExpression>
  private maxSize: number
  private hits = 0
  private misses = 0

  constructor(maxSize = 1000) {
    this.maxSize = maxSize
    this.map = new Map()
  }

  get(key: string): CachedExpression | undefined {
    const entry = this.map.get(key)
    if (entry === undefined) {
      this.misses++
      return undefined
    }
    this.map.delete(key)
    this.map.set(key, entry)
    this.hits++
    return entry
  }

  set(key: string, value: CachedExpression): void {
    if (this.map.has(key)) {
      this.map.delete(key)
    } else if (this.map.size >= this.maxSize) {
      const oldest = this.map.keys().next().value
      if (oldest !== undefined) {
        this.map.delete(oldest)
      }
    }
    this.map.set(key, value)
  }

  getStats(): CacheStats {
    const total = this.hits + this.misses
    return {
      size: this.map.size,
      hits: this.hits,
      misses: this.misses,
      hitRate: total === 0 ? 0 : this.hits / total,
    }
  }

  clear(): void {
    this.map.clear()
    this.hits = 0
    this.misses = 0
  }
}
